import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import { DisposalSet } from '@neptune/cx/utils';

import Splide from '@splidejs/splide';

const gc = new DisposalSet();

registerFragment('chroa-timeline-block', (fragmentElement, config, meta) => {
    const mainSlider = fragmentElement.querySelector<HTMLElement>('.chroa-timeline-block__splide-container');
    const navSlider = fragmentElement.querySelector<HTMLElement>('.timeline-nav');


    if (mainSlider && navSlider) {
        const sourceTitles = (mainSlider as HTMLElement).querySelectorAll<HTMLElement>('[data-timeline-title]');
        const navList = (navSlider as HTMLElement).querySelector<HTMLElement>('.splide__list');

        const mainList = (mainSlider as HTMLElement).querySelector('.splide__list');

        if (mainList) {
            const realSlides = mainSlider.querySelectorAll('.chroa-timeline-slide');
            const slideNodes: Element[] = Array.from(realSlides);

            if (meta.layoutMode === 'view') {
                mainList.innerHTML = '';
                slideNodes.forEach((slideNode) => {
                    const li = document.createElement('li');
                    li.classList.add('splide__slide');
                    li.appendChild(slideNode);
                    mainList.appendChild(li);
                })
            }
        }

        if (navList) {
            // This creates the top slider dynamically
            // without requiring the user to put in info twice
            navList.innerHTML = '';

            sourceTitles.forEach((titleElement) => {
                const li = document.createElement('li');
                li.classList.add('splide__slide', 'chroa-timeline-block__nav__item');

                // title
                const p = document.createElement('p');
                p.classList.add('chroa-timeline-block__nav__title');
                p.innerText = titleElement.innerText;
                li.appendChild(p);

                // SVG?
                const svgNS = "http://www.w3.org/2000/svg";

                const svg = document.createElementNS(svgNS, "svg");
                svg.setAttribute("width", "20");
                svg.setAttribute("height", "20");
                svg.setAttribute("viewBox", "0 0 20 20");
                svg.setAttribute("fill", "none");

                const circle = document.createElementNS(svgNS, "circle");
                circle.setAttribute("cx", "10");
                circle.setAttribute("cy", "10");
                circle.setAttribute("r", "10");
                circle.setAttribute("fill", "#575757");

                svg.appendChild(circle);
                li.appendChild(svg);

                navList.appendChild(li);
            });
        }

        const mainSplide = new Splide(mainSlider as HTMLElement, {
            type: 'slide',
            start: 0,
            pagination: false,
            arrows: true,
            perPage: 1,   // Show 1 big card at a time
            gap: 20,
            speed: 500,
            slideFocus: true,
        });

        const navSplide = new Splide(navSlider as HTMLElement, {
            autoWidth: true,
            gap: 0,
            pagination: false,
            arrows: false,
            isNavigation: true,
            drag: true,
            focus: 0,
            breakpoints: {
                992: {
                    // Turn the center slider features back ON for mobile
                    focus: 'center',
                    perPage: 3,
                    gap: 16,
                    trimSpace: false,

                }
            }
        });

        mainSplide.sync(navSplide);
        mainSplide.mount();
        navSplide.mount();

    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
